import { createContext } from "react"
const ComercialBeds = createContext(null)
export default ComercialBeds
